import { Injectable } from '@angular/core';
import { Service, HttpMethod } from '../../../domain/model/common/service.class';
import { ProfileStatusModel } from '../model/profile-status.model';
import { Observable } from 'rxjs';

@Injectable()
export class ProfileStatusService extends Service {
    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'profileStatus');
    }

    getCurrentUserProfileStatus(): Observable<ProfileStatusModel> {
        return this.get(ProfileStatusModel, 'currentUser');
    }

    setCurrentUserProfileStatus(status): Observable<any> {
        return this.call('currentUser', undefined, status, HttpMethod.POST, true);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/profile-status/service/profile-status.service.ts